import styled from '@emotion/styled'
import { font, spacing } from '@mobi/component-library/Foundations'
import { QuickbetBodyStyled } from '@core/Areas/Quickbet/Components/Common.styles'
import { Text } from '@core/Components/Text'

export const QuickbetDepositBodyStyled = styled(QuickbetBodyStyled)({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '18rem',
  padding: `1.8rem ${spacing.sm} 1rem`,
})

export const QuickDepositBodyContainerStyled = styled.div({
  display: 'flex',
  flex: '1 0 auto',
  flexDirection: 'column',
})

export const LoadingContainerStyled = styled.div({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  '& :not(:last-child)': {
    marginBottom: '1rem',
  },
})

export const QuickDepositLabelStyled = styled(Text)({
  display: 'inline-block',
  lineHeight: 1,
  margin: 0,
  padding: 0,
  textAlign: 'center',
  width: '100%',
})

export const QuickDepositBodySectionStyled = styled.section({
  display: 'flex',
  flex: '1 0 auto',
  flexDirection: 'column',

  '> header > *': {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minHeight: '6.1rem',
  },

  '> div': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    ...font.size.sm,

    '> *': {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      minHeight: '4.1rem',
    },

    '> button:last-child': {
      marginBottom: '4.1rem',
    },
  },
})
